export default function getTrekByTrekNameFactory(ajax, getSession) {
  return async function getTrekByTrekName(id) {
    return ajax({
      resource: `lodgings/lodges/${id}`,
      method: 'get',
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/getTrekByTrekName.js